<template>
  <section>
    <div class="title is-5 has-text-centered">
      Consolidado
      <hr class="dropdown-divider" aria-role="menuitem" />
    </div>

    <b-table :data="data" striped hoverable>
      <b-table-column
        field="area"
        label="Área Académica"
        width="30%"
        v-slot="props"
      >
        {{ props.row.area }}
      </b-table-column>

      <b-table-column
        field="hours_committed_weekly"
        label="Horas/Semana Comprometidas"
        width="30%"
        v-slot="props"
      >
        {{ props.row.hours_committed_weekly }}
      </b-table-column>

      <b-table-column
        field="hours_committed_yearly"
        label="Horas/Año Comprometidas"
        width="30%"
        v-slot="props"
      >
        {{ props.row.hours_committed_yearly }}
      </b-table-column>

      <b-table-column
        field="committee_score"
        label="Nota Comisión"
        width="10%"
        v-slot="props"
      >
        <span v-if="!props.row.has_activities">---</span>
        <span v-else-if="props.row.committee_score === null">Sin calificación</span>
        <span v-else>{{ props.row.committee_score.toFixed(2) }}</span>
      </b-table-column>
    </b-table>

    <div>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th style="width: 30%"></th>
            <th style="width: 30%">Semanales</th>
            <th style="width: 30%">Anuales</th>
            <th style="width: 10%"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 30%">Horas Cronológicas Promedio Anual</td>
            <td style="width: 30%">{{ hours_weekly }}</td>
            <td style="width: 30%">{{ hours_yearly }}</td>
            <td style="width: 10%"></td>
          </tr>

          <tr>
            <td style="width: 30%">Horas Semanales Equivalentes Totales</td>
            <td style="width: 30%">{{ hours_eq }} <b>(Máximo 44 Horas)</b></td>
            <td style="width: 30%"></td>
            <td style="width: 10%"></td>
          </tr>

          <tr>
            <td style="width: 30%"><b>Nota Final Comisión</b></td>
            <td style="width: 30%">{{ final_committee_score }}</td>
            <td style="width: 30%"></td>
            <td style="width: 10%"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  name: "AcademicConsolidated",

  props: ["academic_areas", "performances", "final_note"],

  data() {
    return {
      data: [],
      hours_weekly: 0.0,
      hours_yearly: 0.0,
      hours_eq: 0.0,
      final_committee_score: '---',
    };
  },

  created() {
    this.getConsolidated();
    this.calculateConsolidated();
  },

  methods: {
    getConsolidated() {
      this.data = this.academic_areas.map((area) => {
        return {
          academic_area_id: area.id,
          area: area.alt_name,
          hours_committed_weekly: 0.0,
          hours_committed_yearly: 0.0,
          hours_committed_weekly_1: 0.0,
          hours_committed_yearly_1: 0.0,
          hours_committed_weekly_2: 0.0,
          hours_committed_yearly_2: 0.0,
          percentage: 0.0,
          committee_score: null,
          has_activities: false,
        };
      });
    },

    calculateConsolidated() {
      this.data.forEach((area) => {
        area.hours_committed_weekly = 0.0;
        area.hours_committed_yearly = 0.0;
        area.hours_committed_weekly_1 = 0.0;
        area.hours_committed_yearly_1 = 0.0;
        area.hours_committed_weekly_2 = 0.0;
        area.hours_committed_yearly_2 = 0.0;
      });

      this.performances.forEach((performance) => {
        let area = this.data.find(
          (area) => area.academic_area_id === performance.academic_area_id
        );
        let area_index = this.data.findIndex(
          (area) => area.academic_area_id === performance.academic_area_id
        );
        if (area) {
          if (performance.is_weekly_hours) {
            area.hours_committed_weekly_1 += parseFloat(
              performance.hours_committed_semester_1
            );
            area.hours_committed_weekly_2 += parseFloat(
              performance.hours_committed_semester_2
            );
          } else {
            area.hours_committed_yearly_1 += parseFloat(
              performance.hours_committed_semester_1
            );
            area.hours_committed_yearly_2 += parseFloat(
              performance.hours_committed_semester_2
            );
          }
          this.data[area_index] = area;
        }
      });

      let total = 0.0;

      this.data.forEach((area) => {
        area.hours_committed_weekly = parseFloat(
          (
            (area.hours_committed_weekly_1 + area.hours_committed_weekly_2) /
            2
          ).toFixed(1)
        );
        area.hours_committed_yearly = parseFloat(
          (
            area.hours_committed_yearly_1 + area.hours_committed_yearly_2
          ).toFixed(1)
        );
        total += area.hours_committed_weekly * 36 + area.hours_committed_yearly;
      });

      this.hours_weekly = parseFloat(
        this.data
          .reduce((acc, area) => acc + area.hours_committed_weekly, 0.0)
          .toFixed(1)
      );
      this.hours_yearly = parseFloat(
        this.data
          .reduce((acc, area) => acc + area.hours_committed_yearly, 0.0)
          .toFixed(1)
      );

      this.hours_eq = parseFloat(
        ((this.hours_weekly * 36 + this.hours_yearly) / 44).toFixed(1)
      );

      this.data.forEach((area) => {
        if (total === 0) {
          area.percentage = 0;
        } else {
          area.percentage = parseFloat(
            (
              ((area.hours_committed_weekly * 36 +
                area.hours_committed_yearly) /
                total) *
              100
            ).toFixed(1)
          );
        }
      });

      // Calcular nota promedio del comité por área
      this.data.forEach((area) => {
        const areaPerformances = this.performances.filter(
          (p) => p.academic_area_id === area.academic_area_id
        );
        
        area.has_activities = areaPerformances.length > 0;
        
        const scores = areaPerformances
          .map((p) => p.precalification_score)
          .filter((score) => score !== null && score !== undefined);
        
        if (scores.length > 0) {
          area.committee_score = scores.reduce((sum, score) => sum + parseFloat(score), 0) / scores.length;
        } else {
          area.committee_score = null;
        }
      });

      // Usar la nota final del performance si está disponible (calculada con ponderaciones)
      // Si no, calcular nota promedio simple
      if (this.final_note !== null && this.final_note !== undefined) {
        this.final_committee_score = parseFloat(this.final_note).toFixed(2);
      } else {
        const hasAnyActivities = this.data.some((area) => area.has_activities);
        const allScores = this.data
          .map((area) => area.committee_score)
          .filter((score) => score !== null);
        
        if (!hasAnyActivities) {
          this.final_committee_score = '---';
        } else if (allScores.length > 0) {
          this.final_committee_score = (
            allScores.reduce((sum, score) => sum + score, 0) / allScores.length
          ).toFixed(2);
        } else {
          this.final_committee_score = 'Sin calificación';
        }
      }
    },
  },

  watch: {
    academic_areas: {
      handler() {
        this.getConsolidated();
      },
      deep: true,
    },

    performances: {
      handler() {
        this.calculateConsolidated();
      },
      deep: true,
    },

    final_note: {
      handler() {
        this.calculateConsolidated();
      },
    },
  },
};
</script>
